module.exports = __webpack_public_path__ + "img/flags/VN.ea2caec.png";